<button
  class="export-button"
  [ngClass]="{ 'export-button-loading': waitingForFile() }"
  (click)="exportToCSV()"
  [matTooltip]="'common.violationsExportToolTip' | labelsProvider"
  matTooltipPosition="below"
>
  @if (waitingForFile()) {
    <mat-progress-spinner class="export-button-spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
  } @else {
    <img src="assets/images/common/export.svg" alt="export" />

    <div>
      {{ 'common.export' | labelsProvider }}
    </div>
  }
</button>
